
<div #insideElement class="nested-select-content">
  <div class="search-select-container">
<!--    <span class="selected-option" *ngIf="selectedOption">-->
<!--      {{ selectedOption }}-->
<!--    </span>-->

    <mat-form-field class="example-full-width mx-auto" [ngStyle]="{'text-align': this.apiService.currentDirection === 'rtl' ? 'right': 'left'}">
      <label class=""> {{'GuildName' | translate}} </label>
      <input matInput type="text"
             style="cursor: pointer"
             id="nestedSelect"
             value=" {{ selectedOption }}"
             class="select-search-group"
             autocomplete="off"
             [attr.size]="searchKeyword.length || 5"
             [placeholder]="selectedOption ? '' : ''"
             [ngModel]="searchKeyword"
             (focus)="showDrp = true;"
             (ngModelChange)="searchInList($event)">
    </mat-form-field>


<!--    <input matInput type="text"-->
<!--           style="cursor: pointer"-->
<!--           value=" {{ selectedOption }}"-->
<!--           class="select-search-group"-->
<!--           [attr.size]="searchKeyword.length || 5"-->
<!--           [placeholder]="selectedOption ? '' : ''"-->
<!--           [ngModel]="searchKeyword"-->
<!--           (focus)="showDrp = true;"-->
<!--           (ngModelChange)="searchInList($event)">-->


  </div>
  <div class="select-container" [ngClass]="{'select-container': this.apiService.currentDirection == 'rtl', 'select-containerLeft': this.apiService.currentDirection == 'ltr'}"
       *ngIf="showDrp">
    <ul class="option-list">
      <ng-template #recursiveList let-list>
        <ng-container *ngFor="let item of list">
          <li class="option-item collapsed-item" *ngIf="!item['hidden--by--filter']" [ngStyle]="{'padding-left': this.apiService.currentDirection == 'ltr' ? '15px' :null}">
            <span class="option-item-content" [ngStyle]="{'padding-left': this.apiService.currentDirection == 'ltr' ? '40px' :null}">
              <span class="collapse-btn" [ngClass]="{'collapse-btn': this.apiService.currentDirection == 'rtl', 'collapse-btnLeft': this.apiService.currentDirection == 'ltr'}"
                    *ngIf="item.children.length > 0; else dotTemp"
                    (click)="toggleItemList($event)">
                <img width="16"
                     src="https://img.icons8.com/ios-filled/50/000000/expand-arrow.png"/>
              </span>
              <ng-template #dotTemp>
                <span class="collapse-btn" [ngStyle]="{'left': this.apiService.currentDirection == 'ltr'? '0': null}">
                  <img width="8"
                       src="https://img.icons8.com/material-outlined/24/000000/inactive-state.png"/>
                </span>
              </ng-template>
              <span class="select-item-title"
                    [class.disabled-search]="item['not--kw'] || (!selectableParent && item.children.length)"
                    (click)="setAsSelected(item.title, item.key ,item['not--kw'], item.children.length > 0)"
                    [innerHTML]="item['highlight-title'] || item.title">
              </span>
            </span>
            <ul class="option-list" *ngIf="item.children.length > 0">
              <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: item.children }"></ng-container>
            </ul>
          </li>
        </ng-container>
      </ng-template>
      <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: filteredList }"></ng-container>
    </ul>
  </div>
</div>
